import axiosInstance from '../../../../../../utils/axios';
import { TwoFactorAuthInitiateRequest, TwoFactorAuthVerifyRequest, TwoFactorMethod } from "./interfaces";

export const initiateTwoFactor = async (
  method: TwoFactorMethod = TwoFactorMethod.EMAIL,
): Promise<void> => {
  const payload: TwoFactorAuthInitiateRequest = { method };
  await axiosInstance.post('/two-factor-auth/initiate', payload);
};

export const verifyTwoFactorActivation = async (
  code: string,
  method: TwoFactorMethod = TwoFactorMethod.EMAIL,
): Promise<void> => {
  const payload: TwoFactorAuthVerifyRequest = { method, code };
  await axiosInstance.post('/two-factor-auth/verify', payload);
};

export const getActivatedTwoFactorMethods = async (): Promise<TwoFactorMethod[]> => {
  const response = await axiosInstance.get<TwoFactorMethod[]>(
    '/two-factor-auth/user',
  );
  return response.data;
};